import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './CarouselSection.css';
import { IMAGES } from '../../assets/image';
import ContinueModal from './ContinueModal';
import applicationService from '../../services/ApplicationService';

const CarouselSection = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const continueButtonRef = useRef(null);

  useEffect(() => {
    if (showModal && continueButtonRef.current) {
      continueButtonRef.current.focus();
    }
  }, [showModal]);

  const handleApplyNow = () => {
    navigate('/ApplicationForm');
  };

  const handleContinue = () => {
    setShowModal(true);
  };

  return (
    <section
      className="carousel-section"
      
      aria-labelledby="carousel-title"
    >
      <div className="carousel-background">
        <img
          src={IMAGES.SlideShowImage}
          alt="Auto refinance savings illustration"
          className="carousel-bg-img"
        />
      </div>

      <div className="carousel-overlay" aria-hidden="true" />

      <div className="layout-container carousel-content">
        <div className="text-container">
          <h1 id="carousel-title" className="carousel-title">
            <span className="hero-color">Start Saving</span> on your Auto<br />
            Loan by <span className="hero-color">Refinancing</span>
          </h1>
          <p className="carousel-subtitle">
            With our competitive interest rates, we are sure to get the best rate for you in less than 10 minutes.
          </p>
        </div>

        <div className="carousel-buttons">
          <div className="btn-apply-wrapper">
            <button className="btn btn-apply" onClick={handleApplyNow} aria-label="Start your application now" >APPLY NOW </button>
          </div>

          <div className="btn-continue-wrapper">
            <button className="btn btn-continue" onClick={handleContinue} aria-haspopup="dialog" aria-expanded={showModal} aria-controls="continue-modal" ref={continueButtonRef}           >
              CONTINUE
            </button>
            <span className="btn-note">*Already Started Application?</span>
          </div>
        </div>
      </div>

      <ContinueModal show={showModal} onHide={() => setShowModal(false)} />
    </section>
  );
};

export default CarouselSection;
